var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "yxtbiz-o2o-enroll-projectset-audit" }, [
    _c(
      "div",
      [
        _c(
          "div",
          { staticClass: "standard-size-16 color-gray-10 font-bolder" },
          [
            _vm._v(
              _vm._s(_vm.$t("pc_biz_enroll_lbl_projectset" /** 报名项目集 */))
            ),
          ]
        ),
        _c(
          "yxtf-row",
          {
            staticClass: "pv24 font-normal font-size-14 border-1px-bottom",
            attrs: { type: "flex" },
          },
          [
            _c(
              "yxtf-col",
              { staticClass: "nowrap mh2 felx-center", attrs: { span: 24 } },
              [
                _c("span", { staticClass: "color-gray-7" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("pc_biz_lbl_projectset_name" /* 项目集名称 */)
                    ) + _vm._s(_vm.$t("pc_biz_enroll_lbl_colon" /* ： */))
                  ),
                ]),
                _c(
                  "yxtf-tooltip",
                  {
                    attrs: {
                      "open-filter": "",
                      content: "dasd",
                      placement: "top",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "yxtbiz-o2o-enroll-audit_ellipsis" },
                      [_vm._v(_vm._s(_vm.info.name))]
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "mv24 standard-size-16 color-gray-10 font-bolder" },
          [
            _vm._v(
              _vm._s(
                _vm.$t("pc_biz_enroll_lbl_subproject_list" /** 子项目列表 */)
              )
            ),
          ]
        ),
        _c(
          "div",
          _vm._l(_vm.getMax3List, function (item) {
            return _c(
              "div",
              {
                key: item.id,
                class:
                  item.projectIntegrateType === 1
                    ? "set-group"
                    : "sub-content mb12",
                attrs: { div: "" },
              },
              [
                item.projectIntegrateType === 1
                  ? _c(
                      "Subproject-group",
                      {
                        staticClass: "mb12",
                        attrs: {
                          title: item.name,
                          num: item.project4IntegrateInfo.length,
                        },
                      },
                      _vm._l(item.project4IntegrateInfo, function (sItem) {
                        return _c("Subproject-item", {
                          key: sItem.id,
                          attrs: { data: sItem },
                        })
                      }),
                      1
                    )
                  : _c("Subproject-item", { attrs: { data: item } }),
              ],
              1
            )
          }),
          0
        ),
        _vm.data.length > 3
          ? _c("Subproject-more", { attrs: { data: _vm.more3Data } })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }